import { makeQuery } from 'shared/utilities';
import { IEducationLessonModel } from 'shared/models';

type RequestType = {
    typeId?: string | null;
}

type ResponseType = {
    items: IEducationLessonModel[];
};

export const educationLessonsClosestQuery = async function (params: RequestType = {}) {
    return await makeQuery<ResponseType>('/education-lessons/closest', { params });
}
